export const ORGANIZATIONS_API = '/api/organizations';

export const ORGANIZATION_SEATS_API = `${ORGANIZATIONS_API}/me/seats`;
